<template>
    <div>
        <p>
            The Digital Archive of JMMP
        </p>
    </div>
</template>

<script>
import Menu from "@/components/Menu";
import { store } from "@/centralStore";
export default {
    name: "SplashPage",
    components: {
        Menu
    },
    data() {
        return {
            store: store.state
        };
    },
    mounted() {
        var myself = this;
        myself.store.splashPage = true;
        setTimeout(function() {
            myself.store.splashPage = false;
            myself.$router.push({ name: "detail" });
        }, 2500);
    }
};
</script>

<style scoped>
@keyframes fontani {
    10% {
        font-variation-settings: "wght" 76, "hght" 536, "prtn" 1000;
    }
    50% {
        font-variation-settings: "wght" 76, "hght" 536, "prtn" 0;
    }
    100% {
        font-variation-settings: "wght" 76, "hght" 536, "prtn" 952;
    }
}
div {
    color: white;
    font-size: 2.3rem;
    line-height: 6rem;
    background-color: black;
    height: 100%;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
@media screen and (min-width: 768px) {
    div {
        font-size: 4rem;
    }
}
p {
    text-align: center;
    font-family: "JMMP Display";
    font-feature-settings: "ss01" on;
    /*animation: fontani 5s infinite;*/
}
</style>
